import { Backdrop, Box, Modal as MuiModal, styled, Fade } from "@mui/material";

const Modal = ({children, sxContent, open, ...modalProps}) => {
    return (
        <MuiModal
            open={open}
            BackdropComponent={BackdropComponent}
            BackdropProps={{ timeout: 0 }}
            {...modalProps}

        >
          <Fade in={open} timeout={100}>
            <ContentContainer sx={sxContent}>
              {children}
            </ContentContainer>
          </Fade>
        </MuiModal>
    )
}

const BackdropComponent = styled(Backdrop)`
    background-color: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(5px);
    transition: none;
`;

const ContentContainer = styled(Box)`
    background-color: #FFFFFF;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.25);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    outline: none;
`;

export default Modal;